// extracted by mini-css-extract-plugin
export default {"lgtBreadcrumb":"Breadcrumb_lgtBreadcrumb__Aiv5C","active":"Breadcrumb_active__sD2Bw"};